export default __webpack_public_path__ + "static/media/face_compare_one.eaaefbbc.jpg";